// JSON.parse without the throwing. Use anywhere we'd otherwise wrap a
// `JSON.parse` in `try { } catch { return null }` — for example, LLM-emitted
// text that may or may not be a JSON envelope, optional cookies, inbound
// webhook payloads (when downstream Zod validation does the real check).
//
// Default `T = never` means callers must opt into the inferred type
// explicitly via the type argument, mirroring `JSON.parse`'s `unknown` shape.
export function parseJsonSafe<T = never>(text: string): T | null {
  try {
    return JSON.parse(text) as T;
  } catch {
    return null;
  }
}
